import request from '@/utils/request' // 获取一些特殊的项目接口
// 查询 参赛人员、审核人员、专家、校级管理员 所负责的项目
export function getAboutMyActivityList(query) {
    return request({
        url: '/xsps/activity/getAboutMyActivityList',
        method: 'get',
        params: query
    })
}
// 查看专家分配作品列表
export function getWorksByPerson(query) {
    return request({
        url: '/xsps/works/getWorksByPerson',
        method: 'get',
        params: query
    })
}
// 上传材料接口
export function getWorksPost(data) {
    return request({
        url: '/xsps/works',
        method: 'post',
        data
    })
}
// 修改材料接口
export function getWorksPut(data) {
    return request({
        url: '/xsps/works',
        method: 'put',
        data
    })
}
//资源类型
export function webUploadList(query) {
    return request({
      url: '/competitionmaterial/big/webUploadList',
      method: 'get',
      params: query
    })
  }
//三级联动查询
export function getUploadTypeList(data) {
    return request({
      url: '/competitionmaterial/small/getUploadTypeList',
      method: 'post',
      data: data
    })
}
// 查询小分类列表
export function listSmall(query) {
    return request({
        url: '/competitionmaterial/small/list',
        method: 'get',
        params: query
    })
}
// 查询项目详细
export function getActivity(id) {
    return request({
      url: '/xsps/activity/' + id,
      method: 'get'
    })
  }
// 报名前是否是备选人员
export function checkActivityUser(query) {
    console.log(query)
    return request({
      url: '/xsps/activity/user/checkActivityUser',
      method: 'get',
      params:query
    })
  }
// 上传作品前验证 报名
export function checkCertificate(query) {
    console.log(query)
    return request({
      url: '/xsps/certificate/checkCertificate',
      method: 'get',
      params:query
    })
  }
//   团队列表
export function listTeam(query) {
    return request({
      url: '/xsps/team/list',
      method: 'get',
      params:query
    })
  }
//  添加团队
export function postTeam(data) {
    return request({
      url: '/xsps/team',
      method: 'post',
      data
    })
  }
// 报名
export function postCertificate(data) {
    return request({
      url: '/xsps/certificate',
      method: 'post',
      data
    })
  }
// 获取当前登录用户 在上传作品页面 团队成员显示(个人参赛不显示)
export function getTeamUserList(params) {
    return request({
      url: '/xsps/certificate/getTeamUserList',
      method: 'get',
      params
    })
  }
// 获取当前登录人参与的项目
export function getMyActivityList(params) {
  return request({
    url: '/xsps/activity/getMyActivityList',
    method: 'get',
    params
  })
}

// 我的作品
export function getMyWorks(params) {
  return request({
    url: '/competitionmaterial/material/myWorks',
    method: 'get',
    params
  })
}
// 查询大赛活动组别列表
export function listActivityGroup(query) {
  return request({
    url: '/xsps/activityGroup/list',
    method: 'get',
    params: query
  })
}
// 查询是否报名
export function getSingUpStatus(id,userId) {
  return request({
    url: '/xsps/certificate/getSingUpStatus?activityId='+id+'&userId='+userId,
    method: 'get',
  })
}
// 查询是否上传过作品
export function getUpdateWorksStatus(id,userId) {
  return request({
    url: '/xsps/certificate/getUpdateWorksStatus?activityId='+id+'&userId='+userId,
    method: 'get',
  })
}

